import { defineSlotRecipe } from '@chakra-ui/react/styled-system';

const splitButtonSlotRecipe = defineSlotRecipe({
  slots: ['root', 'action', 'trigger'],
  className: 'split-button',
  base: {
    action: {
      borderStartEndRadius: 0,
      borderEndEndRadius: 0,
    },
    trigger: {
      borderStartStartRadius: 0,
      borderEndStartRadius: 0,
    },
  },
  variants: {
    variant: {
      primary: {
        trigger: {
          borderWidth: 0,
          borderInlineStartWidth: '1',
          borderInlineStartColor: 'border/on-contrast',
          _hover: {
            borderInlineStartColor: 'border/on-contrast',
            _active: {
              borderInlineStartColor: 'border/on-contrast',
            },
          },
          _active: {
            borderInlineStartColor: 'border/on-contrast',
          },
          // Covers both disabled and loading (Chakra's loading button is also disabled). On the
          // gray bg-disabled background the on-contrast divider would be invisible.
          _disabled: {
            borderInlineStartColor: 'border/strong',
          },
          _open: {
            backgroundColor: 'button/primary/bg-active',
            // _open has no :not(:disabled) guard (unlike _hover/_active) and Zag keeps an already-open
            // menu open when its trigger turns disabled — repeat the disabled colors so they win the tie.
            _disabled: {
              backgroundColor: 'button/primary/bg-disabled',
            },
          },
        },
      },
      secondary: {
        trigger: {
          _open: {
            backgroundColor: 'button/secondary/bg-active',
            borderColor: 'button/secondary/border-active',
            color: 'button/secondary/text-active',
            _icon: { color: 'button/secondary/icon-active' },
            // Same _open vs _disabled tie as the primary variant — disabled colors must win.
            _disabled: {
              backgroundColor: 'button/secondary/bg-disabled',
              borderColor: 'button/secondary/border-disabled',
              color: 'button/secondary/text-disabled',
              _icon: { color: 'button/secondary/icon-disabled' },
            },
          },
        },
      },
    },
  },
  defaultVariants: {
    variant: 'primary',
  },
});

export default splitButtonSlotRecipe;
